import { useState, useEffect } from 'react';

import { Heading4 } from '@ui';

import { toDateInputValue } from '../useDebounceDateFilter';

import * as css from './DateInput.css';

type DateFilterInputProps = {
    label: string;
    value: Date;
    min: Date;
    max: Date;
    onChange: (value: string) => void;
    className?: string;
};

export function DateFilterInput({ label, value, min, max, onChange, className }: DateFilterInputProps) {
    const [inputValue, setInputValue] = useState(() => toDateInputValue(value));
    const valueString = toDateInputValue(value);

    useEffect(() => {
        setInputValue(valueString);
    }, [valueString]);

    return (
        <div className={css.dateCard}>
            <Heading4>{label}</Heading4>
            <input
                type="date"
                className={css.dateInput}
                value={inputValue}
                min={toDateInputValue(min)}
                max={toDateInputValue(max)}
                onChange={(e) => {
                    const nextValue = e.target.value;

                    setInputValue(nextValue);
                    onChange(nextValue);
                }}
            />
        </div>
    );
}
